import { NavLink } from "react-router";

const navItems = [
  { to: "/", label: "Inicio", icon: "🏠" },
  { to: "/expenses", label: "Gastos", icon: "💳" },
  { to: "/transfers", label: "Transf.", icon: "🔄" },
  { to: "/savings", label: "Ahorros", icon: "🏦" },
  { to: "/stats", label: "Stats", icon: "📊" },
  { to: "/settings", label: "Ajustes", icon: "⚙️" },
];

export default function BottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-10 border-t border-slate-800 bg-slate-950">
      <div className="flex justify-around">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center gap-0.5 py-2 text-[10px] transition ${
                isActive ? "text-primary" : "text-slate-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className="text-base">{item.icon}</span>
                <span className={isActive ? "font-medium" : ""}>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
